import { api } from '@/shared/api/client';

export interface NotificationSettingsOut {
  settings: Record<string, boolean>;
}

export const notificationApi = {
  list: (subscriptionId?: string) =>
    api.get<NotificationSettingsOut>(
      subscriptionId
        ? `/api/v1/notification-settings?subscription_id=${subscriptionId}`
        : '/api/v1/notification-settings',
    ),
  set: (event_type: string, enabled: boolean, subscription_id?: string | null) =>
    api.put<void>('/api/v1/notification-settings', {
      event_type,
      enabled,
      subscription_id: subscription_id ?? null,
    }),
};
